import React, { useState, useContext, useEffect } from "react";

import './styles.css';

import PromoCard from "../../components/PromoCard/PromoCard";
import BuyNow from "../../components/Home/BuyNow/BuyNow";

import useAuthClient from '../../hooks/useAuthClient';
import useSetPageTitle from "../../hooks/useSetPageTitle";

import UserContext from "../../contexts/UserContext";

import useFetchPromos from "hooks/useFetchPromos";

function Promos() {
    const { currentPromo } = useContext(UserContext);
    useAuthClient(currentPromo);
    useSetPageTitle('Promoções', currentPromo);

    const { promos, fetch} = useFetchPromos();
    const [thisPromo, setThisPromo] = useState(null);
    const [otherPromos, setOtherPromos] = useState([]);

    useEffect(() => {
        const allPromos = promos.map((p) => {
            let status = null;
            let description = null;

            if (p.status === 'finished' || (p.status === 'closed' && !p.participating)) {
                description = 'Promoção Finalizada';
                status = 'finished';
            } else if (p.status === 'closed') {
                description = 'Participações encerradas';
                status = 'closed';
            } else if (p.participating) {
                status = 'joined';
                description = 'PARABÉNS! Agora, é só fazer uma compra pelo app, WhatsApp ou vendedor para ativar o seu cadastro e começar a acumular números da sorte!';
            } else if (p.eligible) {
                description = 'A promoção começou! Clique no botão abaixo para participar!';
                status = 'join';
            } else {
                description = 'Não elegível';
                status = 'not-eligible';
            };


            return {
                id: p.id,
                title: p.titulo,
                path: p.path,
                description,
                status,
            };
        });

        setThisPromo(allPromos.find(p => p.id === currentPromo.id));
        setOtherPromos([
            {
                id: -1,
                title: 'Toby Camisa 10',
                path: 'camisa10',
                description: 'Promoção finalizada!',
                status: 'finished',
            }, {
                id: -2,
                title: 'Toby Show de Prêmios',
                path: 'showdepremios',
                description: 'Promoção finalizada!',
                status: 'finished',
            },
            ...allPromos.filter(p => p.id !== currentPromo.id)
        ].reverse());
    }, [currentPromo, promos]);

    return (
        <div className="container">
            
            {!!thisPromo && (
                <>
                    <div className="current-promo">
                        {
                            <PromoCard
                                promo={thisPromo}
                                onParticipate={() => fetch()}
                            />
                        }
                    </div>
                    {['join', 'joined'].includes(thisPromo.status) && 
                        <BuyNow promo={thisPromo} />
                    }
                    <hr/>
                </>
            )}

            <h1 className="old-promos">Outras Promoções</h1>
            <div className="promos-container">
                {
                    otherPromos
                    .map((promo) => (
                        <PromoCard
                            key={promo.id}
                            promo={promo}
                        />
                    ))
                }
            </div>
        </div>
    )
}

export default Promos;
